const APP_SHELL_ID = 'app-shell'
const GAME_CONTAINER_ID = 'game-container'
const DESKTOP_FRAME_QUERY = '(pointer: fine) and (min-width: 900px) and (min-height: 700px)'
let desktopZoomGuardInstalled = false

export interface AppViewport {
  left: number
  top: number
  width: number
  height: number
}

function requireElement(id: string): HTMLElement {
  const element = document.getElementById(id)
  if (!element) {
    throw new Error(`Missing required app element: #${id}`)
  }
  return element
}

export function getAppShell(): HTMLElement {
  return requireElement(APP_SHELL_ID)
}

export function getGameContainer(): HTMLElement {
  return requireElement(GAME_CONTAINER_ID)
}

export function mountToAppShell(node: HTMLElement): void {
  getAppShell().appendChild(node)
}

export function getAppViewport(): AppViewport {
  const rect = getGameContainer().getBoundingClientRect()
  return {
    left: rect.left,
    top: rect.top,
    width: Math.max(1, Math.round(rect.width)),
    height: Math.max(1, Math.round(rect.height)),
  }
}

export function isDesktopFrameMode(): boolean {
  return window.matchMedia?.(DESKTOP_FRAME_QUERY).matches ?? false
}

export function toViewportLocal(clientX: number, clientY: number): { x: number; y: number } {
  const viewport = getAppViewport()
  return {
    x: clientX - viewport.left,
    y: clientY - viewport.top,
  }
}

export function installDesktopZoomGuard(): void {
  if (desktopZoomGuardInstalled) return
  desktopZoomGuardInstalled = true

  const preventZoomShortcut = (event: KeyboardEvent): void => {
    if (!isDesktopFrameMode()) return
    if (!event.ctrlKey && !event.metaKey) return
    if (!['+', '-', '=', '_', '0'].includes(event.key)) return
    event.preventDefault()
  }

  const preventZoomWheel = (event: WheelEvent): void => {
    if (!isDesktopFrameMode()) return
    if (!event.ctrlKey && !event.metaKey) return
    event.preventDefault()
  }

  window.addEventListener('keydown', preventZoomShortcut, { passive: false })
  window.addEventListener('wheel', preventZoomWheel, { passive: false })
}
